module.exports = __webpack_public_path__ + "static/media/2020-dec-2.9ae41edc.png";